import React from 'react';
import Head from 'next/head';

import SweepVechicleSearch from '../../components/VehicleSearch/Sweep';

export default function UsedEVsPage() {
  return (
    <>
      <Head>
        <title>Used EVs | Nevo</title>
      </Head>

      <SweepVechicleSearch />
    </>
  )
}
